/** RHF `Path<T>` can't express a dynamic prefix, so this one cast keeps `useWatch`/`Controller` inference. */
export const createOrganField =
  (namePrefix = '') =>
  <K extends string>(key: K): K =>
    `${namePrefix}${key}` as K;

export type OrganFieldBuilder = ReturnType<typeof createOrganField>;

export type OrganScopedSectionProps = {
  /** e.g. `organData.Liver.` - omit for a flat, single-organ form. */
  namePrefix?: string;
};

export type OrganAdditionalInfoSectionProps = OrganScopedSectionProps & {
  title?: string;
  showReasonForUnallocated?: boolean;
  showMatchId?: boolean;
};
